import { ENDPOINTS } from '@/config/endpoints.js';

export async function exchangeGithubCode(code, client) {
  return client.get(ENDPOINTS.GH_LOGIN, { searchParams: { code } }).json();
}

export async function fetchSession(client) {
  return client.post(ENDPOINTS.USER).json();
}

export async function logoutSession(client) {
  return client.get(ENDPOINTS.GH_LOGOUT).json();
}
